import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import {
  InvalidEmailVerificationCodeError,
  UnexpectedError,
} from 'utils/errors';
import { getM8AuthURL } from 'services/production/utils/getM8URL';

type Params = {
  code: string;
};

export const processAuthorizationEmailCode = async (params: Params) => {
  const fetchURL = getM8AuthURL('processAuthorizationEmailCode');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    if (response.status === 400) {
      throw new InvalidEmailVerificationCodeError();
    }

    throw new UnexpectedError();
  }
};
